export default __webpack_public_path__ + "static/media/img_login.63a72d0f.png";